"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseDiscount = void 0;
const CountryTier_1 = require("../definitions/CountryTier");
class BaseDiscount {
    setNext(handler) {
        this.nextHandler = handler;
        return handler;
    }
    next(criteria) {
        if (this.nextHandler !== undefined) {
            return this.nextHandler.getDiscountInformation(criteria);
        }
        return { percentage: 0, countryTier: CountryTier_1.CountryTier.INELIGIBLE };
    }
    getDiscountInformation(criteria) {
        if (this.canHandle(criteria)) {
            const discount = this.handle();
            return this.constructDiscountInformation(discount.percentage, discount.countryTier, discount.basePrice, criteria.durationAmount, criteria.durationPeriod);
        }
        else {
            return this.next(criteria);
        }
    }
    constructDiscountInformation(percentage, countryTier, basePrice, durationAmount, durationPeriod) {
        let discountInformation = {
            percentage,
            countryTier
        };
        if (basePrice) {
            const basePricePerUnitNotRounded = this.calculatePricePerUnit(basePrice, durationAmount, durationPeriod);
            const discountPricePerUnitNotRounded = this.calculateDiscountPrice(basePricePerUnitNotRounded, percentage);
            const basePricePerUnit = Math.round(basePricePerUnitNotRounded);
            const discountPricePerUnit = Math.round(discountPricePerUnitNotRounded);
            discountInformation.priceInformation = {
                basePrice,
                basePricePerUnit,
                discountPricePerUnit
            };
        }
        return discountInformation;
    }
    calculateDiscountPrice(basePrice, percentage) {
        return basePrice - (basePrice * percentage / 100);
    }
    calculatePricePerUnit(price, durationAmount, durationPeriod) {
        if (durationPeriod === 'months' && durationAmount && durationAmount > 12) {
            return price / durationAmount * 12;
        }
        return price;
    }
}
exports.BaseDiscount = BaseDiscount;
